(() => {
  'use strict';

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const body = document.body;
  const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const dictionaries = {
    nl: {
      empty: 'Je winkelwagen is leeg.', loading: 'Laden…', cartLoadError: 'Winkelwagen kon niet worden geladen.', qty: 'Aantal', invalidVariant: 'Ongeldige variant', addError: 'Kon niet aan winkelwagen toevoegen', adding: 'Toevoegen…', added: 'Toegevoegd ✓', retry: 'Probeer opnieuw', add: 'In winkelwagen', sold: 'Laat me weten zodra beschikbaar', stock: 'Op voorraad', cartError: 'Winkelwagenfout'
    },
    de: {
      empty: 'Dein Warenkorb ist leer.', loading: 'Laden…', cartLoadError: 'Warenkorb konnte nicht geladen werden.', qty: 'Menge', invalidVariant: 'Ungültige Variante', addError: 'Konnte nicht zum Warenkorb hinzugefügt werden', adding: 'Hinzufügen…', added: 'Hinzugefügt ✓', retry: 'Erneut versuchen', add: 'In den Warenkorb', sold: 'Benachrichtige mich, wenn verfügbar', stock: 'Auf Lager', cartError: 'Warenkorbfehler'
    },
    fr: {
      empty: 'Votre panier est vide.', loading: 'Chargement…', cartLoadError: 'Impossible de charger le panier.', qty: 'Qté', invalidVariant: 'Variante invalide', addError: 'Impossible d’ajouter au panier', adding: 'Ajout…', added: 'Ajouté ✓', retry: 'Réessayer', add: 'Ajouter au panier', sold: 'Prévenez-moi dès disponibilité', stock: 'En stock', cartError: 'Erreur du panier'
    },
    fa: {
      empty: 'سبد خرید شما خالی است.', loading: 'در حال بارگذاری…', cartLoadError: 'سبد خرید بارگذاری نشد.', qty: 'تعداد', invalidVariant: 'گزینه محصول نامعتبر است', addError: 'افزودن به سبد خرید انجام نشد', adding: 'در حال افزودن…', added: 'اضافه شد ✓', retry: 'دوباره تلاش کنید', add: 'افزودن به سبد خرید', sold: 'وقتی موجود شد خبرم کن', stock: 'موجود', cartError: 'خطای سبد خرید'
    },
    ar: {
      empty: 'سلة التسوق فارغة.', loading: 'جارٍ التحميل…', cartLoadError: 'تعذر تحميل سلة التسوق.', qty: 'الكمية', invalidVariant: 'خيار المنتج غير صالح', addError: 'تعذر الإضافة إلى سلة التسوق', adding: 'جارٍ الإضافة…', added: 'تمت الإضافة ✓', retry: 'حاول مرة أخرى', add: 'أضف إلى السلة', sold: 'أبلغني عند التوفر', stock: 'متوفر', cartError: 'خطأ في سلة التسوق'
    },
    en: {
      empty: 'Your cart is empty.', loading: 'Loading…', cartLoadError: 'Could not load cart.', qty: 'Qty', invalidVariant: 'Invalid variant', addError: 'Could not add to cart', adding: 'Adding…', added: 'Added ✓', retry: 'Try again', add: 'Add to cart', sold: 'Notify me when available', stock: 'In stock', cartError: 'Cart error'
    }
  };
  const copy = dictionaries[lang] || dictionaries.en;
  const shopRoot = window.Shopify?.routes?.root || '/';

  /* MBF entrance: logo pulse + neural/electric visuals; heartbeat is the only entrance audio; entrance remains until explicit enter/skip. */
  const entryGate = qs('[data-mbf-entry]');
  if (entryGate) {
    let seen = false;
    try { seen = sessionStorage.getItem('mbf_entry_seen_v5') === '1'; } catch (_) {}
    const isThemePreview =
      Boolean(window.Shopify?.designMode) ||
      /(?:[?&])(preview_theme_id|preview_key)=/i.test(window.location.search) ||
      Boolean(document.querySelector('#preview-bar-iframe, iframe[src*="theme-preview"], [data-shopify-preview-bar]'));
    if (isThemePreview) seen = false;

    let heartCtx = null;
    let heartTimer = null;
    let heartbeatRunning = false;
    let heartMaster = null;
    let entering = false;
    const activeHeartNodes = new Set();

    const ensureHeartContext = async () => {
      try {
        if (!heartCtx) {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) return null;
          heartCtx = new AudioCtx();
        }
        if (heartCtx.state === 'suspended') {
          try { await heartCtx.resume(); } catch (_) {}
        }
        return heartCtx;
      } catch (_) {
        return null;
      }
    };

    const ensureHeartMaster = (ctx) => {
      if (heartMaster) return heartMaster;
      const compressor = ctx.createDynamicsCompressor();
      compressor.threshold.setValueAtTime(-18, ctx.currentTime);
      compressor.knee.setValueAtTime(16, ctx.currentTime);
      compressor.ratio.setValueAtTime(4, ctx.currentTime);
      compressor.attack.setValueAtTime(0.003, ctx.currentTime);
      compressor.release.setValueAtTime(0.16, ctx.currentTime);

      heartMaster = ctx.createGain();
      heartMaster.gain.setValueAtTime(1.06, ctx.currentTime);
      heartMaster.connect(compressor);
      compressor.connect(ctx.destination);
      return heartMaster;
    };

    const trackNode = (node) => {
      activeHeartNodes.add(node);
      node.addEventListener?.('ended', () => activeHeartNodes.delete(node), { once:true });
      return node;
    };

    const synthThump = (ctx, when, strength = 1) => {
      const master = ensureHeartMaster(ctx);

      // Main thump: tuned high enough to remain audible on phone speakers,
      // while keeping the character low and percussive rather than "beepy".
      const osc = trackNode(ctx.createOscillator());
      const gain = ctx.createGain();
      const filter = ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.value = 260;
      filter.Q.value = 0.7;
      osc.type = 'sine';
      osc.frequency.setValueAtTime(142, when);
      osc.frequency.exponentialRampToValueAtTime(72, when + 0.15);
      gain.gain.setValueAtTime(0.0001, when);
      gain.gain.exponentialRampToValueAtTime(0.46 * strength, when + 0.010);
      gain.gain.exponentialRampToValueAtTime(0.0001, when + 0.20);
      osc.connect(filter);
      filter.connect(gain);
      gain.connect(master);
      osc.start(when);
      osc.stop(when + 0.22);

      // Low body keeps the impact physical on headphones / larger speakers.
      const bodyOsc = trackNode(ctx.createOscillator());
      const bodyGain = ctx.createGain();
      bodyOsc.type = 'triangle';
      bodyOsc.frequency.setValueAtTime(88, when);
      bodyOsc.frequency.exponentialRampToValueAtTime(44, when + 0.18);
      bodyGain.gain.setValueAtTime(0.0001, when);
      bodyGain.gain.exponentialRampToValueAtTime(0.22 * strength, when + 0.012);
      bodyGain.gain.exponentialRampToValueAtTime(0.0001, when + 0.21);
      bodyOsc.connect(bodyGain);
      bodyGain.connect(master);
      bodyOsc.start(when);
      bodyOsc.stop(when + 0.23);

      // Very short presence layer so iPhone speakers do not lose the heartbeat.
      const presenceOsc = trackNode(ctx.createOscillator());
      const presenceGain = ctx.createGain();
      const presenceFilter = ctx.createBiquadFilter();
      presenceFilter.type = 'lowpass';
      presenceFilter.frequency.value = 420;
      presenceOsc.type = 'sine';
      presenceOsc.frequency.setValueAtTime(205, when);
      presenceOsc.frequency.exponentialRampToValueAtTime(108, when + 0.09);
      presenceGain.gain.setValueAtTime(0.0001, when);
      presenceGain.gain.exponentialRampToValueAtTime(0.16 * strength, when + 0.006);
      presenceGain.gain.exponentialRampToValueAtTime(0.0001, when + 0.105);
      presenceOsc.connect(presenceFilter);
      presenceFilter.connect(presenceGain);
      presenceGain.connect(master);
      presenceOsc.start(when);
      presenceOsc.stop(when + 0.12);
    };

    const heartbeatCycle = () => {
      if (!heartbeatRunning || !heartCtx || heartCtx.state !== 'running' || entryGate.hidden) return;
      const now = heartCtx.currentTime + 0.02;
      synthThump(heartCtx, now, 0.84);
      synthThump(heartCtx, now + 0.265, 1.0);
    };

    const startHeartbeat = async () => {
      const ctx = await ensureHeartContext();
      if (!ctx || ctx.state !== 'running') {
        heartbeatRunning = false;
        return false;
      }
      ensureHeartMaster(ctx);
      if (heartbeatRunning && heartTimer) return true;

      heartbeatRunning = true;
      try {
        heartMaster.gain.cancelScheduledValues(ctx.currentTime);
        heartMaster.gain.setValueAtTime(1.06, ctx.currentTime);
      } catch (_) {}

      heartbeatCycle();
      heartTimer = window.setInterval(heartbeatCycle, 1750);
      return true;
    };

    const stopHeartbeat = () => {
      heartbeatRunning = false;
      if (heartTimer) {
        window.clearInterval(heartTimer);
        heartTimer = null;
      }
      activeHeartNodes.forEach((node) => {
        try { node.stop(); } catch (_) {}
      });
      activeHeartNodes.clear();
    };
    entryGate.__mbfStopHeartbeat = stopHeartbeat;

    const finishEntry = (animated = true) => {
      if (!entryGate || entryGate.hidden || entering) return;
      entering = true;
      try { sessionStorage.setItem('mbf_entry_seen_v5', '1'); } catch (_) {}

      const complete = () => {
        stopHeartbeat();
        entryGate.classList.remove('is-active', 'is-opening');
        entryGate.hidden = true;
        entryGate.setAttribute('aria-hidden', 'true');
        setBodyLock();
        try { heartCtx?.close(); } catch (_) {}
      };

      if (animated && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        entryGate.classList.add('is-opening');
        window.setTimeout(complete, 1080);
      } else {
        complete();
      }
    };

    if (!seen) {
      entryGate.hidden = false;
      entryGate.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        entryGate.classList.add('is-active');
        setBodyLock();
        qs('.mbf-entry__stage', entryGate)?.focus({ preventScroll: true });
      });

      const openButton = qs('[data-mbf-entry-open]', entryGate);

      const triggerEntryHaptic = (pattern = [35,45,55]) => {
        try {
          if (navigator.vibrate) navigator.vibrate(pattern);
        } catch (_) {}
      };

      // Browsers that allow audible autoplay will start the heartbeat immediately.
      startHeartbeat();

      // iPhone/iPad browsers block audible autoplay until the first real user gesture.
      // Unlock Web Audio synchronously inside that gesture, then start the heartbeat.
      const unlockHeartbeat = () => {
        try {
          if (!heartCtx) {
            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            if (!AudioCtx) return;
            heartCtx = new AudioCtx();
          }
          const afterResume = () => {
            if (!entryGate.hidden) startHeartbeat();
          };
          if (heartCtx.state === 'suspended') {
            const resumed = heartCtx.resume();
            if (resumed?.then) resumed.then(afterResume).catch(() => {});
            else afterResume();
          } else {
            afterResume();
          }
        } catch (_) {}
      };
      if ('PointerEvent' in window) {
        document.addEventListener('pointerdown', unlockHeartbeat, { once:true, capture:true });
      } else {
        document.addEventListener('touchstart', unlockHeartbeat, { once:true, capture:true, passive:true });
      }

      openButton?.addEventListener('pointerdown', () => {
        // Keep the audio unlock on the exact logo gesture Safari trusts.
        unlockHeartbeat();
        triggerEntryHaptic([22,55,34]);
        openButton.classList.add('is-haptic-open');
        window.setTimeout(() => openButton.classList.remove('is-haptic-open'), 380);
      }, { once:true });

      openButton?.addEventListener('click', async () => {
        await startHeartbeat();
        triggerEntryHaptic([45,35,70]);
        // Keep the gate visible long enough for the full double heartbeat to be heard.
        window.setTimeout(() => finishEntry(true), 720);
      });

      qs('[data-mbf-entry-skip]', entryGate)?.addEventListener('click', () => {
        stopHeartbeat();
        finishEntry(false);
      });

      // Keep the entrance visible until the user explicitly enters or skips.
      // Audible autoplay is attempted immediately; iOS may unlock audio on the first user gesture.
      const retryHeartbeat = () => { if (!entryGate.hidden) startHeartbeat(); };
      window.addEventListener('pageshow', retryHeartbeat);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') retryHeartbeat();
      });
      document.addEventListener('keydown', unlockHeartbeat, { once:true, capture:true });
    }
  }

    const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `€${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const setBodyLock = () => {
    const anyOpen = !qs('[data-mbf-cart-drawer]')?.hidden || !qs('[data-mbf-ai-modal]')?.hidden || !qs('[data-mbf-mobile-menu]')?.hidden || !qs('[data-mbf-entry]')?.hidden;
    body.classList.toggle('is-locked', anyOpen);
  };

  /* Mobile navigation */
  const mobileMenu = qs('[data-mbf-mobile-menu]');
  qsa('[data-mbf-menu-open]').forEach((el) => el.addEventListener('click', () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    setBodyLock();
  }));
  qsa('[data-mbf-menu-close]').forEach((el) => el.addEventListener('click', () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    setBodyLock();
  }));

  /* Cart drawer */
  const cartDrawer = qs('[data-mbf-cart-drawer]');
  const cartBody = qs('[data-mbf-cart-body]');
  const cartFooter = qs('[data-mbf-cart-footer]');

  const updateCartBadge = (count) => {
    qsa('[data-mbf-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = !count;
    });
  };

  const renderCart = (cart) => {
    if (!cartBody || !cartFooter) return;
    updateCartBadge(cart.item_count || 0);

    if (!cart.item_count) {
      cartBody.innerHTML = `<div class="drawer__empty"><strong>${copy.empty}</strong></div>`;
      cartFooter.hidden = true;
      return;
    }

    cartBody.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${item.image}" alt="">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span>${item.variant_title}</span>` : '';
      return `
        <article class="drawer-item">
          <a href="${item.url}">${image}</a>
          <div class="drawer-item__copy">
            <a href="${item.url}">${item.product_title}</a>
            ${variant}
            <span>${copy.qty} ${item.quantity}</span>
          </div>
          <div class="drawer-item__price">${money(item.final_line_price)}</div>
        </article>`;
    }).join('');

    const subtotal = qs('[data-mbf-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    cartFooter.hidden = false;
  };

  const fetchCart = async () => {
    const response = await fetch(`${shopRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(copy.cartLoadError);
    return response.json();
  };

  const openCart = async () => {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    if (cartBody) cartBody.innerHTML = `<div class="drawer__loading">${copy.loading}</div>`;
    setBodyLock();
    try { renderCart(await fetchCart()); } catch (_) {
      if (cartBody) cartBody.innerHTML = `<div class="drawer__empty">${copy.cartLoadError}</div>`;
    }
  };

  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    setBodyLock();
  };

  qsa('[data-mbf-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  qsa('[data-mbf-cart-close]').forEach((el) => el.addEventListener('click', closeCart));

  const addToCart = async (variantId, quantity = 1) => {
    const numericId = String(variantId || '').replace(/\D/g, '');
    if (!numericId) throw new Error(copy.invalidVariant);
    const response = await fetch(`${shopRoot}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(numericId), quantity: Math.max(1, Number(quantity) || 1) }] })
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result?.description || result?.message || copy.addError);
    const cart = await fetchCart();
    renderCart(cart);
    return cart;
  };

  qsa('[data-mbf-quick-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      const original = button.textContent;
      button.disabled = true;
      button.textContent = copy.adding;
      try {
        await addToCart(button.dataset.variantId, 1);
        button.textContent = copy.added;
        await openCart();
      } catch (error) {
        button.textContent = error.message || copy.retry;
      } finally {
        window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1400);
      }
    });
  });

  /* Product page */
  const productRoot = qs('[data-mbf-product-root]');
  if (productRoot) {
    const variantInput = qs('[data-mbf-product-variant-input]', productRoot);
    const priceEl = qs('[data-mbf-product-price]', productRoot);
    const stockEl = qs('[data-mbf-product-stock]', productRoot);
    const selectedLabel = qs('[data-mbf-selected-variant]', productRoot);
    const addButton = qs('[data-mbf-product-add]', productRoot);
    const addLabel = qs('[data-mbf-product-add-label]', productRoot);
    const stickyPrice = qs('[data-mbf-sticky-price]');

    qsa('[data-mbf-variant]', productRoot).forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        qsa('[data-mbf-variant]', productRoot).forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (priceEl) priceEl.textContent = button.dataset.variantPrice || '';
        if (stickyPrice) stickyPrice.textContent = button.dataset.variantPrice || '';
        if (selectedLabel) selectedLabel.textContent = button.dataset.variantTitle || '';
        const available = button.dataset.variantAvailable === 'true';
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? copy.add : copy.sold;
        if (stockEl) {
          stockEl.textContent = available ? copy.stock : copy.sold;
          stockEl.classList.toggle('status-pill--in', available);
          stockEl.classList.toggle('status-pill--out', !available);
        }
        if (button.dataset.variantImage) {
          const main = qs('[data-mbf-gallery-main]', productRoot);
          if (main) {
            main.src = button.dataset.variantImage;
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
          }
          const mainWrap = qs('[data-mbf-gallery-main-wrap]', productRoot);
          if (mainWrap && button.dataset.variantImageId) {
            mainWrap.dataset.mbfMainImageId = button.dataset.variantImageId;
          }
          const lightboxImage = qs('[data-mbf-lightbox-image]', productRoot) || qs('[data-mbf-lightbox-image]');
          if (lightboxImage) {
            lightboxImage.src = button.dataset.variantImage;
            lightboxImage.removeAttribute('srcset');
            lightboxImage.removeAttribute('sizes');
          }
          const targetImageId = button.dataset.variantImageId || '';
          qsa('[data-mbf-gallery-thumb]', productRoot).forEach((thumb) => {
            const active = targetImageId && thumb.dataset.imageId === targetImageId;
            thumb.classList.toggle('is-active', active);
            if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
        }
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(button.dataset.variantId).replace(/\D/g, ''));
          history.replaceState({}, '', url);
        } catch (_) {}
      });
    });

    const qtyInput = qs('[data-mbf-qty-input]', productRoot);
    qs('[data-mbf-qty-minus]', productRoot)?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) - 1);
    });
    qs('[data-mbf-qty-plus]', productRoot)?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + 1);
    });

    const addForm = qs('#MBFProductForm', productRoot);
    addForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!variantInput || !addButton) return;
      const original = addLabel?.textContent || copy.add;
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = copy.adding;
      try {
        await addToCart(variantInput.value, qtyInput?.value || 1);
        if (addLabel) addLabel.textContent = copy.added;
        await openCart();
      } catch (error) {
        if (addLabel) addLabel.textContent = error.message || copy.retry;
      } finally {
        window.setTimeout(() => {
          addButton.disabled = false;
          if (addLabel) addLabel.textContent = original;
        }, 1400);
      }
    });

    qsa('[data-mbf-gallery-thumb]', productRoot).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = qs('[data-mbf-gallery-main]', productRoot);
        if (!main || !thumb.dataset.src) return;
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        const mainWrap = qs('[data-mbf-gallery-main-wrap]', productRoot);
        if (mainWrap && thumb.dataset.imageId) {
          mainWrap.dataset.mbfMainImageId = thumb.dataset.imageId;
        }
        qsa('[data-mbf-gallery-thumb]', productRoot).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    qsa('[data-mbf-gallery-carousel]', productRoot).forEach((carousel) => {
      const rail = qs('[data-mbf-gallery-rail]', carousel);
      if (!rail) return;
      const step = () => Math.max(180, Math.round(rail.clientWidth * 0.78));
      qs('[data-mbf-gallery-prev]', carousel)?.addEventListener('click', () => {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      qs('[data-mbf-gallery-next]', carousel)?.addEventListener('click', () => {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });

    const lightbox = qs('[data-mbf-product-lightbox]', productRoot.parentElement || document);
    const lightboxImage = lightbox ? qs('[data-mbf-lightbox-image]', lightbox) : null;
    const lightboxOpen = qs('[data-mbf-lightbox-open]', productRoot);
    const lightboxClose = lightbox ? qs('[data-mbf-lightbox-close]', lightbox) : null;
    const closeProductLightbox = () => {
      if (!lightbox?.open) return;
      lightbox.close();
    };
    lightboxOpen?.addEventListener('click', () => {
      const main = qs('[data-mbf-gallery-main]', productRoot);
      if (!lightbox || !lightboxImage || !main) return;
      lightboxImage.src = main.currentSrc || main.src;
      lightboxImage.alt = main.alt || '';
      document.body.classList.add('mbf-product-lightbox-open');
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      lightboxClose?.focus({ preventScroll: true });
    });
    lightboxClose?.addEventListener('click', closeProductLightbox);
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeProductLightbox();
    });
    lightbox?.addEventListener('close', () => {
      document.body.classList.remove('mbf-product-lightbox-open');
      lightboxOpen?.focus({ preventScroll: true });
    });

    const sticky = qs('[data-mbf-sticky-atc]');
    if (sticky && addButton && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      const observer = new IntersectionObserver(([entry]) => {
        const isVisible = !entry.isIntersecting && window.scrollY > 380;
        sticky.classList.toggle('is-visible', isVisible);
        document.body.classList.toggle('mbf-sticky-atc-visible', isVisible);
      }, { threshold: 0.1 });
      observer.observe(addButton);
    }
    qs('[data-mbf-sticky-add]')?.addEventListener('click', () => addButton?.click());
  }

  /* Collection filters */
  qs('[data-mbf-filter-toggle]')?.addEventListener('click', () => qs('.filters')?.classList.toggle('is-open'));

  /* AI assistant */
  const aiModal = qs('[data-mbf-ai-modal]');
  const aiFrame = qs('[data-mbf-ai-frame]');
  let aiOrigin = '';
  try { aiOrigin = new URL(aiFrame?.dataset.src || '', window.location.href).origin; } catch (_) {}

  const openAI = (event) => {
    if (!aiModal || !aiFrame) return;
    if (!aiFrame.getAttribute('src')) {
      const rawContext = event?.currentTarget?.dataset?.mbfAiContext || document.title || 'The Muscle Body Factory';
      try {
        const frameUrl = new URL(aiFrame.dataset.src || '', window.location.href);
        frameUrl.searchParams.set('context', String(rawContext).slice(0, 500));
        aiFrame.src = frameUrl.toString();
      } catch (_) {
        aiFrame.src = aiFrame.dataset.src || '';
      }
    }
    aiModal.hidden = false;
    setBodyLock();
  };
  const closeAI = () => {
    if (!aiModal) return;
    aiModal.hidden = true;
    setBodyLock();
  };
  qsa('[data-mbf-ai-open]').forEach((el) => el.addEventListener('click', openAI));
  qsa('[data-mbf-ai-close]').forEach((el) => el.addEventListener('click', closeAI));

  /* Secure parent-page bridge for the existing MBF AI iframe. */
  window.addEventListener('message', async (event) => {
    if (!aiFrame || event.source !== aiFrame.contentWindow || !aiOrigin || event.origin !== aiOrigin) return;
    const data = event.data;
    if (!data || data.source !== 'thembf-ai' || data.type !== 'MBF_ADD_TO_CART') return;
    const requestId = String(data.requestId || '');
    try {
      await addToCart(data.variantId, data.quantity || 1);
      event.source?.postMessage({ source: 'thembf-store', type: 'MBF_CART_RESULT', requestId, ok: true }, aiOrigin);
      closeAI();
      await openCart();
    } catch (error) {
      event.source?.postMessage({ source: 'thembf-store', type: 'MBF_CART_RESULT', requestId, ok: false, error: error instanceof Error ? error.message : copy.cartError }, aiOrigin);
    }
  });

  /* Escape closes overlays */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (entryGate && !entryGate.hidden) {
      try { sessionStorage.setItem('mbf_entry_seen_v5', '1'); } catch (_) {}
      entryGate.__mbfStopHeartbeat?.();
      entryGate.classList.remove('is-active', 'is-opening');
      entryGate.hidden = true;
      entryGate.setAttribute('aria-hidden', 'true');
    }
    closeCart();
    closeAI();
    if (mobileMenu) mobileMenu.hidden = true;
    setBodyLock();
  });
})();
